import React, { Component } from 'react';
import Circle from '../../../../../img/ComponentAsImage/Circle';
import {
  COMPARE_CHART_LEGENDS,
  LABEL_OF_LEGEND,
  LABEL_OF_LEGEND_ACTIVE,
  LABEL_TEXT,
} from '../../constants/CompareChartLegendsConstants';

class CompareChartLegends extends Component {
  constructor(props) {
    super(props);
  }
  getLabelClassnameBasedOnActiveOrNot(key) {
    if (this.isActiveLabel(key)) {
      return LABEL_OF_LEGEND_ACTIVE;
    } else {
      return LABEL_OF_LEGEND;
    }
  }

  isActiveLabel(key) {
    return this.props.activeLabel.key === key;
  }

  renderCompareChartLegends() {
    return this.props.compareChartLegends.map((item, index) => (
      <div
        className={this.getLabelClassnameBasedOnActiveOrNot(item.key)}
        onClick={() => this.props.setActiveLabel(item)}
        key={item.key}
      >
        <Circle fill={item.color} active={this.isActiveLabel(item.key)}></Circle>
        <p className={LABEL_TEXT}>{item.text}</p>
      </div>
    ));
  }
  render() {
    return <div className={COMPARE_CHART_LEGENDS}>{this.renderCompareChartLegends()}</div>;
  }
}

export default CompareChartLegends;



// WEBPACK FOOTER //
// ./src/features/home/components/compare/chart/CompareChartLegends.js